React = require 'react'
t = require('views/internal/recup-with-helpers')('home')

module.exports = class HomeTab extends React.Component
  displayName: 'HomeTab'

  render: t.renderable ->
    { url, selected, name, logoHash, iconClass } = @props

    if logoHash
      orgLogoUrl1x = "#{window.logoDomain}/#{logoHash}/30.png"
      orgLogoUrl2x = "#{window.logoDomain}/#{logoHash}/170.png"

    t.div { class: t.classify('home-tab': true, 'selected': selected) }, ->
      t.a '.home-tab-link', { href: url }, ->
        if logoHash
          t.img '.home-tab-icon', {
            src: orgLogoUrl1x
            srcSet: "#{orgLogoUrl1x} 1x, #{orgLogoUrl2x} 2x"
          }
        else
          t.icon(iconClass, { class: 'home-tab-icon' })

        t.span '.home-tab-text', ->
          if name == 'home'
            t.format 'home'
          else
            t.text name



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-tab.coffee